
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/adgerdir",
      function () {
        return require("private-next-pages/adgerdir.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/adgerdir"])
      });
    }
  